import React from "react";
import { TypeAnimation } from "react-type-animation";
import About from "../About/About";
import Contact from "../Contact/Contact";
import Project from "../Project/Project";
import Skills from "../Skills/Skills";

const Home = () => {
  return (
    <div className="text-center">
      <div className="md:my-24 my-10 md:mx-8 mx-5">
        <TypeAnimation
          sequence={[
            "HEY,",
            1000,
            "I'M ",
            1000,
            "MD EMON HOSSAIN",
            1000,
            "MD EMON HOSSAIN",
            1000,
            "",
            500,
          ]}
          style={{ fontSize: "2em" }}
          wrapper="div"
          repeat={Infinity}
        />
        <h1 className="text-4xl text-green-500 font-bold text-center">
          <TypeAnimation
            sequence={[
              "Front-End Developer",
              1000,
              "Back-End Developer",
              1000,
              "",
              500,
            ]}
            style={{ fontSize: "1em" }}
            wrapper="div"
            repeat={Infinity}
          />
        </h1>
        <p className="text-2xl">
          I Will Make Website Using React.js and react-router-dom. <br /> And
          for Back-End Using Express.js MongoDB Build a full stack website using
          fonts and back-end This Technology
        </p>
        <div className="mt-14">
          <a href="#project">
            <button className="btn bg-stone-800">Project </button>
          </a>
          <a href="#skills">
            <button className="btn mx-2 bg-stone-800">Skills</button>
          </a>
        </div>
      </div>
      <div className="mt-20  my-20">
        <About></About>
      </div>
      <div className="my-20">
        <div className="flex justify-center">
          <h1 className="text-2xl mb-7 bg-stone-800 w-2/5 text-white p-2 rounded-lg ">
            Skills
          </h1>
        </div>
        <div className="flex justify-center md:mx-6 lg:mx-8 mx-5">
          <Skills></Skills>
        </div>
      </div>
      <div className="my-20  md:flex md:justify-center md:mx-5 lg:mx-8 mx-5">
        <Project></Project>
      </div>
      <div>
        <Contact></Contact>
      </div>
    </div>
  );
};

export default Home;
